// 文書ディスパッチ結果model
export class DispatchDocumentResult {
  public manageType: number;
  public subType: number;
  public targetId: number;
  public isEditable: boolean;
}
